var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c("div", { staticClass: "row gutter-sm" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("slug"), disable: true },
            model: {
              value: _vm.slug,
              callback: function($$v) {
                _vm.slug = $$v
              },
              expression: "slug"
            }
          }),
          _c("p", { staticClass: "text-weight-light q-caption" }, [
            _vm._v("solicitar ao desenvolvimento o slug")
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("q-select", {
            ref: "group_training_type",
            attrs: {
              options: _vm.badge_types,
              "float-label": _vm.$t("badge_type")
            },
            on: { input: _vm.clearData },
            model: {
              value: _vm.badge_type,
              callback: function($$v) {
                _vm.badge_type = $$v
              },
              expression: "badge_type"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-xs-12 col-sm-12 " }, [
        _c("div", { staticClass: "row gutter-sm flex" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("uploader", {
                attrs: {
                  content_type: "images",
                  multiple: false,
                  cropper: true,
                  aspect_ratio: 1 / 1,
                  aspect_ratio_string: "1/1"
                },
                on: { fileUploaded: _vm.imageUploaded }
              }),
              _vm.image
                ? _c(
                    "p",
                    { staticClass: "q-mt-md file-url" },
                    [
                      _c("q-icon", {
                        attrs: { name: "fal fa-check", color: "positive" }
                      }),
                      _c(
                        "a",
                        { attrs: { href: _vm.image, target: "_blank" } },
                        [_vm._v(" " + _vm._s(_vm.$truncateLink(_vm.image)))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
            _c(
              "p",
              { staticClass: "caption" },
              [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.$t("alt_image")) +
                    "\n\t\t\t\t\t\t"
                ),
                _c(
                  "q-icon",
                  {
                    staticClass: "q-ml-sm q-pb-sm",
                    attrs: {
                      name: "fal fa-question-circle",
                      size: "1.5rem",
                      color: "grey"
                    }
                  },
                  [
                    _c(
                      "q-tooltip",
                      {
                        staticClass: "custom-tooltip",
                        attrs: { anchor: "top left", self: "bottom right" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("alt_image_information_helper")) +
                            "\n\t\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex justify-between" },
              [
                _vm._l(_vm.languages, function(lang) {
                  return [
                    lang.code === "pt-br"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_br",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_br.$error
                              },
                              on: { input: _vm.$v.language_br.$touch },
                              model: {
                                value: _vm.language_br,
                                callback: function($$v) {
                                  _vm.language_br = $$v
                                },
                                expression: "language_br"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    lang.code === "en-us"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_us",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_us.$error
                              },
                              on: { input: _vm.$v.language_us.$touch },
                              model: {
                                value: _vm.language_us,
                                callback: function($$v) {
                                  _vm.language_us = $$v
                                },
                                expression: "language_us"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    lang.code === "es-es"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_es",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_es.$error
                              },
                              on: { input: _vm.$v.language_es.$touch },
                              model: {
                                value: _vm.language_es,
                                callback: function($$v) {
                                  _vm.language_es = $$v
                                },
                                expression: "language_es"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    lang.code === "fr-fr"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_fr",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_fr.$error
                              },
                              on: { input: _vm.$v.language_fr.$touch },
                              model: {
                                value: _vm.language_fr,
                                callback: function($$v) {
                                  _vm.language_fr = $$v
                                },
                                expression: "language_fr"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-tabs",
            {
              staticClass: "shadow-1",
              attrs: { color: "secondary" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _vm._l(_vm.laguages, function(l, index) {
                return _c("q-tab", {
                  key: "t-" + index,
                  attrs: { slot: "title", name: "tab-" + l.id, label: l.name },
                  slot: "title"
                })
              }),
              _vm._l(_vm.laguages, function(l, index) {
                return _c(
                  "q-tab-pane",
                  { key: "tp-" + index, attrs: { name: "tab-" + l.id } },
                  [
                    _vm.getTitle
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("q-input", {
                                  attrs: { "float-label": _vm.$t("title") },
                                  model: {
                                    value: _vm.getTitle.title,
                                    callback: function($$v) {
                                      _vm.$set(_vm.getTitle, "title", $$v)
                                    },
                                    expression: "getTitle.title"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c("q-input", {
                                  attrs: {
                                    "float-label": _vm.$t("description")
                                  },
                                  model: {
                                    value: _vm.getTitle.description,
                                    callback: function($$v) {
                                      _vm.$set(_vm.getTitle, "description", $$v)
                                    },
                                    expression: "getTitle.description"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm.badge_type === 1
        ? _c("div", { staticClass: "row gutter-sm q-mt-xs" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
              _c("p", { staticClass: "caption" }, [
                _vm._v(_vm._s(_vm.$t("countries")))
              ]),
              _c(
                "div",
                { staticClass: "row gutter-sm" },
                [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          val: true,
                          label: _vm.$t("select_all_countries")
                        },
                        on: {
                          input: function($event) {
                            return _vm.checkAllCountries()
                          }
                        },
                        model: {
                          value: _vm.all_countries,
                          callback: function($$v) {
                            _vm.all_countries = $$v
                          },
                          expression: "all_countries"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(_vm.countries, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "col-xs-12 col-sm-4",
                        class: _vm.getErrorClass(_vm.$v.country.$error)
                      },
                      [
                        _c("q-checkbox", {
                          ref: "country",
                          refInFor: true,
                          attrs: {
                            "keep-color": "",
                            val: item.value,
                            label: item.label,
                            color: _vm.getErrorColor(_vm.$v.country.$error)
                          },
                          model: {
                            value: _vm.country,
                            callback: function($$v) {
                              _vm.country = $$v
                            },
                            expression: "country"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ]),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("areas")))
                ]),
                _c("q-checkbox", {
                  staticClass: "q-mb-sm",
                  attrs: { val: true, label: _vm.$t("select_all_areas") },
                  on: {
                    input: function($event) {
                      return _vm.checkAllAreas()
                    }
                  },
                  model: {
                    value: _vm.all_areas,
                    callback: function($$v) {
                      _vm.all_areas = $$v
                    },
                    expression: "all_areas"
                  }
                }),
                _c("q-select", {
                  ref: "area",
                  attrs: {
                    filter: "",
                    "autofocus-filter": "",
                    options: _vm.areas,
                    error: _vm.$v.area.$error,
                    multiple: "",
                    chips: ""
                  },
                  model: {
                    value: _vm.area,
                    callback: function($$v) {
                      _vm.area = $$v
                    },
                    expression: "area"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
              _c("p", { staticClass: "caption" }, [
                _vm._v(_vm._s(_vm.$t("profiles")))
              ]),
              _c(
                "div",
                { staticClass: "row gutter-sm" },
                [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-checkbox", {
                        attrs: { val: true, label: _vm.$t("all") },
                        on: {
                          input: function($event) {
                            return _vm.checkAll()
                          }
                        },
                        model: {
                          value: _vm.all_profiles,
                          callback: function($$v) {
                            _vm.all_profiles = $$v
                          },
                          expression: "all_profiles"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(_vm.profiles, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "col-xs-12 col-sm-4",
                        class: _vm.getErrorClass(_vm.$v.profile.$error)
                      },
                      [
                        _c("q-checkbox", {
                          ref: "profile",
                          refInFor: true,
                          attrs: {
                            "keep-color": "",
                            val: item.value,
                            label: item.label,
                            color: _vm.getErrorColor(_vm.$v.profile.$error)
                          },
                          model: {
                            value: _vm.profile,
                            callback: function($$v) {
                              _vm.profile = $$v
                            },
                            expression: "profile"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ]),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  ref: "user_group",
                  attrs: {
                    options: _vm.user_groups,
                    "float-label": _vm.$t("groups"),
                    error: _vm.$v.user_group.$error,
                    multiple: "",
                    chips: ""
                  },
                  on: { input: _vm.$v.user_group.$touch },
                  model: {
                    value: _vm.user_group,
                    callback: function($$v) {
                      _vm.user_group = $$v
                    },
                    expression: "user_group"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("p", { staticClass: "caption" }, [
            _vm._v(_vm._s(_vm.$t("status")))
          ]),
          _c("q-btn-toggle", {
            attrs: {
              "toggle-color": _vm.getColorStatus,
              options: _vm.statuses
            },
            model: {
              value: _vm.status,
              callback: function($$v) {
                _vm.status = $$v
              },
              expression: "status"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "far fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "admin_badges" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }